import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center items-center" }
const _hoisted_2 = ["src"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 2,
  class: "empty-workloads--content mt-[32px]"
}
const _hoisted_5 = { class: "flex flex-col gap-[16px] justify-center items-center" }
const _hoisted_6 = { class: "empty-workloads--title text-[24px] text-Text/text_high font-gordita-medium" }
const _hoisted_7 = {
  key: 0,
  class: "empty-workloads--subtitle text-[14px] leading-[14px] text-Text/text_high font-gordita-regular"
}
const _hoisted_8 = {
  key: 3,
  class: "mt-[24px] text-center"
}
const _hoisted_9 = { class: "mt-[40px] mb-[32px] text-[24px] text-Text/text_high font-gordita-medium" }
const _hoisted_10 = { class: "mt-[12px] text-Text/text_medium gordita-regular-14" }
const _hoisted_11 = { class: "block" }

import empty_search from '@/assets/images/agents/empty_search.svg';
import { IncrediButton } from 'incredi-ui';
import empty_builds from '@/assets/images/workloads/noWorkloads.svg';


export default /*#__PURE__*/_defineComponent({
  __name: 'emptyWorkloads',
  props: {
    hasFiltersApplied: { type: Boolean },
    buttonText: null,
    imgType: null,
    title: null,
    subtitle: null
  },
  emits: ["clearFilters"],
  setup(__props: any, { emit }: { emit: ({ (e: 'clearFilters'): void }), expose: any, slots: any, attrs: any }) {


const clearFilters = () => {
  emit('clearFilters');
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.imgType == 'search' || (__props.hasFiltersApplied && __props.imgType !== 'builds'))
      ? (_openBlock(), _createElementBlock("img", {
          key: 0,
          src: _unref(empty_search),
          alt: "empty-search"
        }, null, 8, _hoisted_2))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _unref(empty_builds),
          alt: "empty_builds"
        }, null, 8, _hoisted_3)),
    (__props.hasFiltersApplied)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(__props.title || 'No Results Found'), 1),
            (__props.subtitle)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(__props.subtitle), 1))
              : _createCommentVNode("", true)
          ]),
          (__props.hasFiltersApplied)
            ? (_openBlock(), _createBlock(_unref(IncrediButton), {
                key: 0,
                design: "primary-green",
                size: "small",
                rounded: true,
                class: "text-[13px] text-center mt-[12px] font-gordita-medium",
                onClick: clearFilters
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(__props.buttonText), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('workloads.workloadsTable.noBuildsFound.title')), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('workloads.workloadsTable.noBuildsFound.a')), 1)
          ])
        ]))
  ]))
}
}

})